import { Component, OnInit } from '@angular/core';
import { BannerService } from '../services/banner.service';
import { environment } from '../../../environments/environment';
import { HttpEventType } from '@angular/common/http';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-banner-list',
  templateUrl: './banner-list.component.html',
  styleUrls: ['./banner-list.component.css'],
})
export class BannerListComponent implements OnInit {
  saveOrder() {
    const divBanners = document.getElementById('listBanner').children;

    this.changes = [];
    for (let index = 0; index < divBanners.length - 1; index++) {
      this.changes.push(divBanners[index].children[1].innerHTML);
    }
    this.bannerService.changeOrder(this.changes).then((res) => {
      console.log(res);
    });
  }
  banners = [];
  changes = [];
  env = environment;
  file: File;

  constructor(private bannerService: BannerService) {
    this.getBanners();
  }

  ngOnInit(): void {}

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.banners, event.previousIndex, event.currentIndex);
    const current: HTMLCollection[] = this.banners[event.currentIndex];

    const child = event.container.element.nativeElement.children;
  }

  async getBanners() {
    this.banners = await this.bannerService.getBanners();
  }

  remove(file_name: string) {
    if (confirm('Deseja remover esse banner ?')) {
      this.bannerService.delete(file_name).then(() => {
        this.getBanners();
      });
    }
  }

  sendFile() {
    const formData = new FormData();
    formData.append('banner', this.file, this.file.name);
    this.bannerService.add(formData).subscribe((event) => {
      if (event.type === HttpEventType.Response && event.status === 200) {
        setTimeout(() => {
          this.getBanners();
        }, 1000);
      }
    });
  }

  async selectFile($event) {
    this.file = $event.target.files[0];

    const image = new Image();
    image.onload = function (e: any) {
      const { height, width } = e.path[0];
      console.log(height, width);
    };
    image.src = URL.createObjectURL(this.file);

    await this.fileToBlod().then((res) => {});
  }

  fileToBlod(): Promise<any> {
    return new Promise((resolver, reject) => {
      try {
        const read = new FileReader();
        read.addEventListener('load', (res: ProgressEvent<FileReader>) => {
          resolver(res.target.result);
        });

        read.readAsText(this.file);
      } catch (error) {
        reject(error);
      }
    });
  }
}
